function activateField(input) {
	const container = input.closest('.float-container');

	if (!container) {
		return;
	}

	container.classList.add('active');

	const placeholder = input.dataset.placeholder;

	if (placeholder !== undefined) {
		input.setAttribute('placeholder', placeholder);
	}
}

function deactivateField(input) {
	const container = input.closest('.float-container');

	if (!container) {
		return;
	}

	if (!input.value.trim()) {
		container.classList.remove('active');
	}

	input.removeAttribute('placeholder');
}

function initializeField(container) {
	const input = container.querySelector('input, textarea, select');

	if (!input) {
		return;
	}

	if (input.value) {
		container.classList.add('active');
	}

	input.addEventListener('focus', () => {
		activateField(input);
	});

	input.addEventListener('blur', () => {
		deactivateField(input);
	});

	input.addEventListener('change', () => {
		if (input.value) {
			container.classList.add('active');
		} else {
			container.classList.remove('active');
		}
	});
}

export function initFloatLabels() {
	const containers = document.querySelectorAll('.float-container');

	containers.forEach(initializeField);
}
